var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('view-card', {
    attrs: {
      "title": "연락처"
    }
  }, [_vm.isAuthorized ? _c('v-row', {
    attrs: {
      "slot": "title-actions"
    },
    slot: "title-actions"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('view-contact-modify', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.expert,
      callback: function callback($$v) {
        _vm.expert = $$v;
      },
      expression: "expert"
    }
  })], 1)], 1) : _vm._e(), _c('data-list', {
    attrs: {
      "dataList": _vm.dataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }